import React, { Component } from "react";
import ProjectSet from "./ProjectSet";
import InstallUpdateLog from "./InstallUpdateLog";
import UserManagement from "./UserManagement";
import HistoryVersion from "./HistoryVersion";
import ReleaseNewVersion from "./ReleaseNewVersion";
import DocumentTitle from "react-document-title";

import "./index.css";
import BsyAlertMenu from "../BsyAlertMenu";
import BsyDialog from "../BsyDialog";
import AddProjectContent from "./AddProjectContent";
import Tree from "rc-tree";
import { BsyUtils } from "../../utils/Utils";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyDateTime from "../BsyDateTime";
import BsySLoading from "../BsySLoading";
import BsyAlert from "../BsyAlert";
import { setPageTitle } from "../../utils/setPageTitle";


class BsyVirtualReleaseManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 1,
      expandedKeys: ["1"],
      selectedKeys: 1,
      isEnter: false,
      treeNodes: [],
      selectProjectType: 1,
      treeData: [],
      projectTypeList: [
        {
          name: React.language("user.management"),
          id: 1
        }, {
          name: React.language("release.new.version"),
          id: 2
        }, {
          name: React.language("install.log"),
          id: 3
        }, {
          name: React.language("project.set"),
          id: 4
        }, {
          name: React.language("history.version"),
          id: 5
        }
      ],
      entryList: [],
      entryMap: {},
      rightTitle: React.language('release.set'),
      isLoading: true
    }
    this.searchInputRef = React.createRef();
  }

  handleEnterPress = (event) => {
    if (event.key === 'Enter') {
      this.searchData()
    }
  }

  componentWillUnmount() {
    // document.removeEventListener('keydown', this.handleEnterPress);
  }

  componentDidMount() {
    // document.addEventListener('keydown', this.handleEnterPress);
    this.loadListData(null, false, true);
  }

  loadListData = (e, m, y) => {
    this.setState({ isLoading: !m }, () => {
      React.axios("/dashboard/standard_list").then(res => {
        const { list, map } = res.data;
        let selectedKeys = this.state.selectedKeys;
        let expandedKeys = this.state.expandedKeys;
        let t = true;
        if (y) {
          if (!e) {
            list.map(item => {
              if (t) {
                if (item.child) {
                  item.child.map(res => {
                    if (map[res.id].type === 1) {
                      selectedKeys = map[res.id]._id;
                      if (expandedKeys.indexOf(item.id) < 0) {
                        expandedKeys.push(item.id);
                      }
                      t = false;
                    }
                  })
                } else {
                  if (map[item.id] && map[item.id].type === 1) {
                    selectedKeys = map[item.id]._id;
                    t = false;
                  }
                }
              }
            })
          } else {
            selectedKeys = e._id;
          }
        }

        this.setState({
          treeNodes: this._sortEntryList(list, map),
          entryList: list,
          entryMap: map,
          selectedKeys,
          expandedKeys,
          isLoading: false,
        }, () => {
          this._initEntrySort();
        })
      }).catch(() => {
        this.setState({ isLoading: false })
      })
    })
  }

  _initEntrySort = () => {
    let arry = [];
    let child = [];
    let levelChild = 0;
    let newChlid = this.state.treeNodes.filter((string) => {
      return this.state.entryMap[string.id || string._id] && string
    })
    let treeData = newChlid.map(res => {
      return this.createTreeMenuData(res, levelChild, child)
    })
    BsyUtils.forEach(this.state.entryMap, (obj, val) => {
      arry.push(val)
    })
    this.transformToTreeFormat(arry);
    this.setState({ treeData: treeData })
  }

  transformToTreeFormat = (b) => {
    let simpleData = {
      enable: true,
      idKey: "_id",
      pIdKey: "parent"
    }
    var c, d, e = simpleData.idKey, f = simpleData.pIdKey, g = 'children';
    if (!e || "" == e || !b)
      return [];
    if (Array.isArray(b)) {
      var h = []
        , i = [];
      for (c = 0, d = b.length; c < d; c++) {
        i[b[c][e]] = b[c];
      }

      for (c = 0, d = b.length; c < d; c++) {

        if (i[b[c][f]] && b[c][e] != b[c][f]) {
          i[b[c][f]][g] || (i[b[c][f]][g] = [])


          b[c].title = b[c].name;
          b[c].key = b[c][e];
          i[b[c][f]][g].push(b[c])
        } else {
          b[c].title = b[c].name;
          b[c].key = b[c][e];
          h.push(b[c])
        }

      }
      return h
    }
    b.title = b.name;
    b.key = b.entryId;
    return [b]
  }

  _sortEntryList = (a, b) => {
    return a
  }

  addProjectName = ""
  addProjectDesc = ""

  addChangeProjectName = (e) => {
    this.addProjectName = e.target.value.replace(/\s+/g, ' ');
    e.target.value = this.addProjectName;
  }

  addChangeProjectDesc = (e) => {
    this.addProjectDesc = e.target.value.replace(/[\r\n]/g, '');
    e.target.value = this.addProjectDesc;
  }

  getProjectContext = (t) => {
    this.projectContext = t;
  }

  addReleaseProject = (t) => {
    this.addProjectName = t.name
    this.addProjectDesc = t.remark
    BsyDialog({
      title: t === "add" ? React.language('add.project.release.management') : React.language('edit.project.release.management'),
      height: t === "add" ? 680 : 490,
      width: t === "add" ? 966 : 460,
      footerPos: t === "add" ? "left" : "",
      okText: React.language(t === "add" ? "publish.immediate" : "save"),
      cancelText: React.language("cancel"),
      onContentCreate: () => {
        return t === "add" ? <AddProjectContent getContext={this.getProjectContext} /> :
          <div className={"addProjectContent"}>
            <div className="addItem name">
              <div className="itemTitle">
                <span><b>*</b>{React.language(t.type === 1 ? 'project.name' : 'project.group.name')}</span>
              </div>
              <div className="itemValue">
                <input autoFocus={true} type="text" maxLength={128} defaultValue={this.addProjectName}
                  onChange={this.addChangeProjectName}
                  placeholder={React.language("dept.name.placeholder")} />
              </div>
            </div>
            {t.type === 1 && <div className="addItem remark">
              <div className="itemTitle">
                <span>{React.language('project.remark')}</span>
              </div>
              <div className="itemValue">
                <textarea maxLength={1024} defaultValue={this.addProjectDesc} onChange={this.addChangeProjectDesc}
                  placeholder={React.language("project.remark.placeholder")} />
              </div>
            </div>}
          </div>
      },
      onOk: () => {
        if (t === "add") {
          const { addProjectDesc, addProjectName, addDocLink, addDateTime } = this.projectContext;
          const { appIds, installTime, timeType, userSelectType } = this.projectContext.state;
          let limitUnit = "";
          if (timeType === "days") {
            limitUnit = 3;
          } else if (timeType === "month") {
            limitUnit = 2;
          } else if (timeType === "year") {
            limitUnit = 1;
          }
          if (addProjectName === "") {
            tipAlert({
              type: "warning",
              msg: React.language("project.name.placeholder")
            })
            return false;
          }
          if (appIds.length === 0) {
            tipAlert({
              type: "warning",
              msg: React.language('select.release.standard.app.waterMark')
            })
            return false;
          }
          if (installTime === 2 && (Number(addDateTime) < 0 || Number(addDateTime) > 99999)) {
            tipAlert({
              type: "warning",
              msg: React.language('trial.time.after.first.tip')
            })
            return false;
          }
          this.setState({ isLoading: true }, () => {
            React.axios("/dashboard/standard_create", {
              "name": addProjectName,   //最大128
              "remark": addProjectDesc,  //最大1024
              // "app_remark": addProjectDesc,  //最大1024
              // "doc_url": addDocLink,   //最大1024
              "appIds": appIds,
              "mode": userSelectType,  //选择可安装的用户  1只允许指定用户安装 2允许任何人安装（默认这个）
              "limitDays": installTime === 1 ? 0 : Number(addDateTime),   //首次安装后的使用时间 0为不限制 最大99999
              "limitUnit": limitUnit  // 1年 2月 3天
            }).then(res => {
              this.setState({ isLoading: false }, () => {
                this.loadListData(res.data, false, !0)
              })
            }).catch(() => {
              this.setState({ isLoading: false })
            })
          })

        } else {
          if (this.addProjectName === "") {
            tipAlert({
              type: "warning",
              msg: React.language("project.name.placeholder")
            })
            return false;
          }
          this.setState({ isLoading: true }, () => {
            React.axios("/dashboard/standard_update", {
              "name": this.addProjectName,   //最大128
              "remark": this.addProjectDesc,  //最大1024
              "_id": t._id,  //最大1024
            }).then(res => {
              this.setState({ isLoading: false }, () => {
                this.loadListData()
              })
            }).catch(() => {
              this.setState({ isLoading: false })
            })
          })

        }

      }
    })
  }

  addProjectGroupName = ""

  addChangeProjectGroupName = (e) => {
    this.addProjectGroupName = e.target.value.replace(/\s+/g, ' ');
    e.target.value = this.addProjectGroupName;
  }

  validateString = (inputString) => {
    let regex = /^[\u4e00-\u9fa5\w\s]+$/;
    // \u4e00-\u9fa5 表示中文字符范围，\w 表示字母、数字、下划线，\s表示空格

    // 使用test()方法检查输入字符串是否符合正则表达式模式
    return regex.test(inputString);
  }

  addReleaseProjectType = () => {
    this.addProjectGroupName = "";
    BsyDialog({
      title: React.language('add.project.release.management.type'),
      height: 290,
      width: 460,
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onContentCreate: () => {
        return <div className={"addProjectContent"}>
          <div className="addItem name">
            <div className="itemTitle">
              <span><b>*</b>{React.language('project.group.name')}</span>
            </div>
            <div className="itemValue">
              <input autoFocus={true} type="text" maxLength={128} onBlur={this.addChangeProjectGroupName}
                placeholder={React.language("dept.name.placeholder")} />
            </div>
          </div>
        </div>
      },
      onOk: () => {
        if (this.addProjectGroupName === "" || this.addProjectGroupName === " ") {
          tipAlert({
            type: "warning",
            msg: React.language("error.3001")
          })
          return false
        }
        if (!this.validateString(this.addProjectGroupName)) {
          tipAlert({
            type: "warning",
            msg: React.language("virtual.add.name.tip")
          })
          return false
        }
        React.axios("/dashboard/standard_group_create", { name: this.addProjectGroupName }).then((res) => {
          if (res.data.code === 200) {

          }
          tipAlert({
            type: "success",
            msg: React.language("form.ext.add.success")
          })
          this.loadListData();
        })
      }
    })
  }

  addRelease = (event) => {
    const e = event.currentTarget;
    const menu = [
      {
        text: React.language('add.project.release.management'),
        colorType: "",
        icon: "icon-create-group",
        click: () => {
          this.addReleaseProject("add");
        }
      }, {
        text: React.language('add.project.release.management.type'),
        colorType: "",
        icon: "icon-fenzuhuizong",
        click: () => {
          this.addReleaseProjectType();
        }
      }
    ]
    e.parentNode.classList.add("select");

    BsyAlertMenu({
      item: menu,
      width: 160,
      target: event.target,
      customCls: "import-export-item",
      onClose: () => {

        e.parentNode.classList.remove("select")
      }
    })
  }

  createTreeMenuData = (data, levelChild, child) => {
    const { entryMap, entryid, expandedKeys } = this.state;
    let newData = {};
    if (!entryMap[data.id || data._id]) {
      return null
    }
    BsyUtils.forEach(entryMap[data.id || data._id], (key, val) => {
      if (key === "icon") {
        return
      }
      newData[key] = val;
    })
    newData.isLeaf = false;
    newData.title = <></>;
    if (newData.type === 2) {
      newData.levelChild = levelChild;
      newData.parentId = entryMap[data.id || data._id].parent;
      newData.key = data.id || data._id;
      // newData.title = entryMap[data.id || data.entryId].name;
      newData.iconClass = entryMap[data.id || data._id].iconClass || entryMap[data.id || data._id].icon;
      newData.children = [];
      if (data.child && data.child.length > 0) {
        levelChild++;
        let newChlid = data.child.filter((string) => {
          return entryMap[string.id || string._id] && string
        })
        newData.children = newChlid.map(res => {
          return this.createTreeMenuData(res, levelChild, child)
        })
      }

    } else {
      if (newData.key === entryid) {
        let child = [];
        let p = entryid && entryMap[entryid] && entryMap[entryid].parent;
        if (p) {
          child.push(p)
        }
        for (let i = 1; i < levelChild; i++) {
          p = entryMap[p].parent;
          child.push(p)
        }
        this.setState({ expandedKeys: [...child, ...expandedKeys] })
      }
      newData.levelChild = levelChild;
      newData.key = data.id || data._id;
      // newData.title = entryMap[data.id || data.entryId].name;
      newData.iconClass = entryMap[data.id || data._id].iconClass || entryMap[data.id || data._id].icon;
      newData.parentId = data.parent;
    }
    return newData;
  }

  handleMoveNode = (node) => {
    const _this = this;
    let n = node.dragNode;
    let i = node.node;
    let hasChildGroup = false;
    if (n.type === 2 && n.children) {
      for (let i = 0; i < n.children.length; i++) {
        if (n.children[i].type === 2) {
          hasChildGroup = true;
        }
      }
    }

    let parent = i.levelChild === 0 ? "root" : i.parent;
    let before = i._id;
    if (i.expanded && n.type !== 2) {
      parent = i._id;
      before = null;
    }

    if (node.dropPosition < 0) {
      parent = "root";
      before = undefined;
    } else {
      if (n.type === 2 && ((hasChildGroup && i.type === 2 && i.expanded) || (hasChildGroup && i.levelChild > 0) || (i.levelChild > 0 && i.type === 2 && i.expanded) || i.levelChild > 1)) {
        tipAlert({
          type: "warning",
          msg: React.language('max.two.level.group')
        })
        return
      }
    }
    let sortList = {
      target: n && n._id,
      before: before,
      parent: parent
    }
    React.axios("/dashboard/standard_sort", sortList).then(res => {
      this.loadListData();
    })
    // window.FX.Utils.ajax({
    //   url: "/dashboard/app/" + window.FX.STATIC.APPID + "/entry/sort",
    //   data: sortList
    // }, function (d) {
    //   _this.setState({
    //     treeNodes: _this._sortEntryList(d.entryList, d.entryMap),
    //     entryMap: d.entryMap,
    //     entryList: d.entryList,
    //   }, () => {
    //     _this._initEntrySort();
    //   })
    // }, function () {
    //
    // })
  }

  toTarget = (val, expanded) => {
    let { appid, expandedKeys, treeData } = this.state;
    if (val.type === 2) {
      if (expanded) {
        this.setState({ expandedKeys: expanded, treeData: treeData })
      } else {
        if (expandedKeys.indexOf(val._id) > -1) {
          expandedKeys.splice(expandedKeys.indexOf(val._id), 1)
        } else {
          expandedKeys.push(val._id)
        }
        this.setState({ expandedKeys: expandedKeys, treeData: treeData })
      }


    } else {
      // this.initTreescrollTop();
      // window.FX.FORMCACHE && window.FX.FORMCACHE.saveFormData();
      // this.props.history.push({ pathname: `${window.rootDirectroy}/team/app/${appid}/${val.type}/${val.entryId}`, state: { titleName: val.name + " - " + this.state.appName, editAuth: editAuth } })
      if (this.searchInputRef && this.searchInputRef.current) {
        this.searchInputRef.current.value = "";
      }
      this.setState({ selectedKeys: val._id })
    }
  }

  getTimeContext = (e) => {
    this.timeDate = e;
  }

  siteName = "";
  userAccount = "";
  userName = "";
  maturityTime = null;

  addChangeSiteName = (e) => {
    this.siteName = e.target.value
  }

  addChangeUserAccount = (e) => {
    this.userAccount = e.target.value
  }

  addChangeUserName = (e) => {
    this.userName = e.target.value.replace(/\s+/g, ' ');
    e.target.value = this.userName;
  }

  searchText = "";

  addChangeSearchText = (e) => {
    this.searchText = e.target.value;
  }

  openUserManagement = () => {
    const _this = this;
    this.siteName = "";
    this.userAccount = "";
    this.userName = "";
    this.maturityTime = null;
    BsyDialog({
      title: React.language('add.user'),
      height: 490,
      width: 460,
      okText: React.language("add"),
      cancelText: React.language("cancel"),
      onContentCreate: () => {
        return <div className={"addProjectContent"}>
          <div className="addItem site">
            <div className="itemTitle">
              <span><b>*</b>{React.language('project.site')}</span>
            </div>
            <div className="itemValue">
              <input autoFocus={true} type="text" maxLength={128} onBlur={this.addChangeSiteName}
                placeholder={React.language("placeholder.project.site")} />
            </div>
          </div>
          <div className="addItem site">
            <div className="itemTitle">
              <span><b>*</b>{React.language('project.user.account')}</span>
            </div>
            <div className="itemValue">
              <input type="text" maxLength={128} onBlur={this.addChangeUserAccount}
                placeholder={React.language("placeholder.project.user.account")} />
            </div>
          </div>
          <div className="addItem site">
            <div className="itemTitle">
              <span><b>*</b>{React.language('project.user.name')}</span>
            </div>
            <div className="itemValue">
              <input type="text" maxLength={128} onChange={this.addChangeUserName}
                placeholder={React.language("placeholder.project.user.name")} />
            </div>
          </div>
          <div className="addItem site">
            <div className="itemTitle">
              <span>{React.language('maturity.time')}</span>
              <span className="itemMsg">{React.language('maturity.time.msg')}</span>
            </div>
            <div className="itemValue">
              <BsyDateTime
                key={"BsyDateTimeLimit" + new Date().getTime()}
                width={'100%'}
                height={36}
                value={this.maturityTime}
                theme={this.props.theme}
                format={'yyyy-MM-dd HH:mm:ss'}
                width4number={'auto'}
                waterMark={React.language("placeholder.maturity.time")}
                onStopEdit={e1 => {
                  this.maturityTime = this.timeDate.state.value;
                }}
                getContext={this.getTimeContext}
              />
            </div>
          </div>
        </div>
      },
      onOk: () => {
        let maturityTime = !this.maturityTime ? "" : this.maturityTime / 1000;
        if (this.siteName === "") {
          tipAlert({
            type: "warning",
            msg: React.language("placeholder.project.site")
          })
          return false;
        } else if (this.userAccount === "") {
          tipAlert({
            type: "warning",
            msg: React.language("placeholder.project.user.account")
          })
          return false;
        } else if (this.userName === "") {
          tipAlert({
            type: "warning",
            msg: React.language("placeholder.project.user.name")
          })
          return false;
        }

        React.axios("/dashboard/standard_user_add", {
          _id: this.state.selectedKeys,
          sitedomain: this.siteName,
          account: this.userAccount,
          username: this.userName,
          expireTime: maturityTime
        }).then(res => {
          this.userManagementContext.loadData();
        })
      }
    })
  }

  getUserManagementContext = (r) => {
    this.userManagementContext = r;
  }

  getInstallUpdateLogContext = (r) => {
    this.installUpdateLogContext = r;
  }

  searchData = () => {
    const { selectProjectType } = this.state;
    if (selectProjectType === 1) {
      this.userManagementContext.setState({ keyword: this.searchText, skip: 0, }, () => {
        this.userManagementContext.loadData()
      })
    } else if (selectProjectType === 3) {
      this.installUpdateLogContext.setState({ keyword: this.searchText, skip: 0, }, () => {
        this.installUpdateLogContext.loadData()
      })
    }
  }

  redReleaseProject = (r) => {
    if (r.children && r.children.length > 0) {
      tipAlert({
        type: "warning",
        msg: React.language("del.project.group.tip")
      })
      return;
    }


    if (r.type === 2) {
      BsyAlert({
        // title: React.language("api.deleteData"),
        title: React.language("del.project.group.title"),
        type: "swarning",
        text4Ok: React.language("delete"),
        OkType: "red",
        text4Cancel: React.language("cancel"),
        ok: () => {


          React.axios("/dashboard/standard_group_remove", {
            _id: r._id
          }).then(res => {
            tipAlert({
              type: res.data.code === 200 ? "success" : "warning",
              msg: res.data.msg
            })
            this.loadListData()
          })

        }
      })
    } else {
      BsyAlert({
        type: "error-input",
        title: React.language("want.delete.app", { appname: r.name }),
        // msg: React.language("delete.form.irreversible"),
        text4Ok: React.language("delete"),
        OkType: "red",
        placeholder: React.language("delete.app.name"),
        text4Cancel: React.language("cancel"),
        onInputValidate: (val) => {
          return r.name === val;
        },
        ok: (val, el) => {
          React.axios("/dashboard/standard_delete", {
            _id: r._id
          }).then(res => {
            tipAlert({
              type: res.data.code === 200 ? "success" : "warning",
              msg: res.data.msg
            })
            // this.loadListData()
            window.location.reload();
          })

        },
      });
    }


  }

  createFormDashMenu = (res, event) => {
    const e = event.currentTarget;
    const menu = [
      {
        text: React.language('edit'),
        colorType: "",
        icon: "icon-bsy-reportmenu-1",
        click: () => {
          this.addReleaseProject(res);
        }
      }, {
        text: React.language('delete'),
        colorType: "red",
        icon: "icon-close-normal",
        click: () => {
          this.redReleaseProject(res);
        }
      }
    ]
    e.parentNode.classList.add("select");
    BsyAlertMenu({
      item: menu,
      width: 220,
      target: event.target,
      onClose: () => {
        e.parentNode.classList.remove("select")
      }
    })
  }

  render() {
    const {
      type,
      rightTitle,
      selectedKeys,
      expandedKeys,
      treeData,
      isEnter,
      entryMap,
      projectTypeList,
      selectProjectType,
      isLoading
    } = this.state;
    const newExpandedKeys = [...new Set(expandedKeys)];
    let selectVal = {};
    treeData.map(res => {
      if (res.children) {
        res.children.map(res1 => {
          if (res1._id === selectedKeys) {
            selectVal = res1
          }
        })
      } else {
        if (res._id === selectedKeys) {
          selectVal = res
        }
      }
    })


    setPageTitle(`${React.language("project.release.management")} - ${React.language("standard.application")}`);
    return (

      <div className="BsyVirtualReleaseManagement">
        <div className="virtualReleaseManagementCont">
          {isLoading && <BsySLoading style={{ background: '#ffffff' }} />}
          <div className="cont-left">
            <div className="left-title">
              <span>{React.language('project.release.management.list')}</span>
              <i className="icon-bsy-add" onClick={this.addRelease}></i>
            </div>
            <div className="left-menu">
              <Tree
                treeData={treeData}
                isVirtualized={false}
                defaultExpandedKeys={newExpandedKeys}
                expandedKeys={newExpandedKeys}
                selectedKeys={[selectedKeys]}
                onExpand={(expanded, node) => {
                  this.newParentOverNode = null;
                  if (isEnter) {
                    this.setState({ expandedKeys: expanded })
                  } else {
                    this.toTarget(node.node, expanded)
                  }
                }}
                onDragEnter={(node) => {
                  this.setState({ expandedKeys: node.expandedKeys })
                }}
                draggable={!0}
                onDragOver={(node) => {
                  let n = node.node;
                  if (!this.newParentOverNode) {
                    this.newParentOverNode = node;
                  }
                  if (node.dropPosition < 0) {
                    window.FX.UI.closePopover()
                    return
                  }


                  if (this.newParentOverNode.node.key !== n.key) {
                    let i = this.startNode.node;
                    let hasChildGroup = false;

                    if (n.levelChild < 1) {
                      window.FX.UI.closePopover()
                    }
                    if (n.type === 2 && i.type === 2) {
                      return;
                    }
                    if (i.type === 2 && i.children) {
                      for (let f = 0; f < i.children.length; f++) {
                        if (i.children[f].type === 2) {
                          hasChildGroup = true;
                        }
                      }
                    }

                    if (hasChildGroup) {
                      return
                    } else {
                      if (n.levelChild > 1 && n.type === 2) {
                        return
                      }
                    }
                    if (this.sortTime) {
                      clearTimeout(this.sortTime);
                      this.sortTime = null;
                    }
                    if (n.type === 2) {
                      window.FX.UI.closePopover()
                      if (n.expanded) {
                        window.FX.UI.showPopover({
                          anchor: window.$(document.getElementById(n.key)),
                          content: window.$("<span/>").text(React.language("app.edit.group.moveTo", {
                            groupName: n.name
                          })),
                          type: "dark"
                        })
                      } else {
                        this.sortTime = setTimeout(() => {
                          window.FX.UI.showPopover({
                            anchor: window.$(document.getElementById(n.key)),
                            content: window.$("<span/>").text(React.language("app.edit.group.moveTo", {
                              groupName: n.name
                            })),
                            type: "dark"
                          })
                          node.context.triggerExpandActionExpand(node.event, n)
                        }, 500)
                      }

                    } else {
                      if (entryMap[n.parent]) {
                        window.FX.UI.closePopover()
                        window.FX.UI.showPopover({
                          anchor: window.$(document.getElementById(n.key)),
                          content: window.$("<span/>").text(React.language("app.edit.group.moveTo", {
                            groupName: entryMap[n.parent].name
                          })),
                          type: "dark"
                        })
                      }
                    }
                    this.newParentOverNode = node;
                  }
                }}
                onDrop={(node) => {
                  this.newParentOverNode = null;
                  this.startNode = null;
                  window.FX.UI.closePopover();
                  if (this.sortTime) {
                    clearTimeout(this.sortTime);
                    this.sortTime = null;
                  }
                  this.setState({ isEnter: false });
                  this.handleMoveNode(node);
                }}
                onDragEnd={(node) => {
                  if (this.sortTime) {
                    clearTimeout(this.sortTime);
                    this.sortTime = null;
                  }
                  this.startNode = null;
                  window.FX.UI.closePopover()
                }}
                onDragStart={(node) => {
                  if (this.sortTime) {
                    clearTimeout(this.sortTime);
                    this.sortTime = null;
                  }
                  this.startNode = node;
                }}
                icon={(rowInfo) => {
                  return <i
                    className={`icon-bsy-icongengduo1 nav nav-department-edit`}
                    style={{
                      verticalAlign: "middle"
                    }}
                    //自定义菜单点击
                    onClick={(e) => { this.createFormDashMenu(rowInfo.data, e) }}
                  ></i>
                }}
                switcherIcon={(rowInfo) => {
                  return <>
                    {rowInfo.data.type === 2 ? <><i
                      className={(rowInfo.expanded ? 'icon-bsy-folder-open' : 'icon-bsy-folder-close')}></i><span
                        id={rowInfo.data._id} className="rc-tree-group-name"
                        title={rowInfo.data.name} style={{ fontWeight: "bold" }}>{rowInfo.data.name}</span></>
                      : <><span
                        id={rowInfo.data._id} className="rc-tree-group-name"
                        title={rowInfo.data.name} style={{ color: "#666666" }}>{rowInfo.data.name}</span></>}
                  </>
                }}
              />
            </div>
          </div>
          <div className="cont-right">
            {
              selectVal._id && <>
                <div className="right-title-desc-version">
                  <div className="r-title-desc">
                    <span className="r-title">{selectVal.name}</span>
                    <span className="r-desc">{selectVal.remark}</span>
                  </div>
                  {
                    selectVal.version && <div className="r-version">
                      {`${React.language('project.version')} ${selectVal.version}`}
                    </div>
                  }
                </div>
                <div className="right-header">
                  <div className="right-header-left">
                    {
                      projectTypeList.map(res => {
                        return <div className={`leftItem ${res.id === selectProjectType ? "select" : ""}`}
                          onClick={() => {
                            this.searchInputRef.current && (this.searchInputRef.current.value = "");
                            this.setState({ selectProjectType: res.id })
                          }}>
                          <div className="leftItem-title">{res.name}</div>
                        </div>
                      })
                    }
                  </div>
                  {
                    (selectProjectType === 1 || selectProjectType === 3) &&
                    <div className="right-header-right">
                      <div className="header-right-search">
                        <input type="text" ref={this.searchInputRef} placeholder={React.language("please.enter.keyword")} onChange={this.addChangeSearchText} maxLength={1024} />
                        <div className="r-search-btn" onClick={this.searchData}>{React.language("search")}</div>
                      </div>
                      {selectProjectType === 1 && <div className="right-user-management" onClick={this.openUserManagement}>
                        <i className="icon-bsy-add"></i>
                        <span>{React.language("add.user")}</span>
                      </div>}
                    </div>
                  }

                </div>
                <div className="right-body" key={selectedKeys}>
                  {
                    selectProjectType === 1 &&
                    <UserManagement data={selectVal} getContext={this.getUserManagementContext} />
                  }
                  {
                    selectProjectType === 2 && <ReleaseNewVersion data={selectVal} loadListData={() => { this.loadListData(!1, !0) }} />
                  }
                  {
                    selectProjectType === 3 && <InstallUpdateLog data={selectVal} getContext={this.getInstallUpdateLogContext} />
                  }
                  {
                    selectProjectType === 4 && <ProjectSet data={selectVal} loadListData={() => { this.loadListData(!1, !0) }} switchProjectType={(id) => {
                      this.setState({ selectProjectType: id })
                    }} />
                  }
                  {
                    selectProjectType === 5 && <HistoryVersion data={selectVal} />
                  }
                </div>
              </>
            }
          </div>
        </div>
      </div>

    )
  }
}

export default BsyVirtualReleaseManagement;